const data = [
  {
    title: 'How The States Got Their Shapes',
    description:
      'Built with ReactJS and an Express.js API back-end for data hosted on AWS Elastic Beanstalk.  Interactive Mapbox map which displays educational slideshows on specific click events.',
    image: '/images/state-shapes.jpg',
    deployLink: 'http://www.howthestatesgottheirshapes.com',
    githubLink: 'https://github.com/mjm5vp/stateshapes2',
    techs: ['ReactJS', 'Express.js', 'AWS']
  },
  {
    title: 'BBQ Review',
    description:
      'Ruby on Rails site with a PostgreSQL database built with full CRUD functionality and user authentication.  Users can rate which restaurants have their favorite BBQ items and the community rankings aggregate all users’ rankings for each category.',
    image: '/images/bbq_review.jpg',
    deployLink: 'https://bbq-review.herokuapp.com/',
    githubLink: 'https://github.com/mjm5vp/bbq-review',
    techs: ['Ruby', 'Rails', 'PostgreSQL', 'Heroku']
  },
  {
    title: 'Tower of Hanoi',
    description:
      'Classic stone stacking game built with JavaScript, HTML and CSS.  Players can select number of stones while tracking their time and number of moves.',
    image: '/images/towerOfHanoi.jpg',
    deployLink: 'http://www.tower-of-hanoi.com',
    githubLink: 'https://github.com/mjm5vp/Tower-of-Hanoi',
    techs: ['JavaScript', 'JQuery', 'HTML', 'CSS', 'AWS']
  },
  {
    title: 'Brew Mood',
    description:
      'AngularJS app with a Ruby on Rails API backend.  Using data from a brewery API, this app allows users to sort and search through thousands of beers and breweries by ABV%, bitterness, serving temperature and even glass type.',
    image: '/images/brew_mood.jpg',
    deployLink: 'http://brewmood.com.s3-website-us-east-1.amazonaws.com/#/',
    githubLink: 'https://github.com/mjm5vp/beerApp',
    techs: ['AngularJS', 'Ruby', 'Rails', 'AWS']
  }
]

const techs = [
  'JavaScript',
  'React',
  'React Native',
  'Redux',
  'Angular 7',
  'Ruby',
  'Rails',
  'Java Spring Boot',
  'Firebase',
  'Express.js',
  'Node.js',
  'MERN/MEAN Stack',
  'PostgreSQL',
  'MongoDB',
  'JQuery',
  'HTML',
  'SASS/CSS',
  'Git / Github',
  'AWS'
]

module.exports = {
  data,
  techs
}



// WEBPACK FOOTER //
// ./src/projectData.js